import Vue from 'vue'
import VeeValidate from 'vee-validate'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
// import VueWaypoint from 'vue-waypoint'
// import VueScrollTo from 'vue-scrollto'

const vendors = () => {
  Vue.use(VeeValidate)
  // Vue.use(VueAwesomeSwiper)
  // Vue.use(VueWaypoint)
  // Vue.use(VueScrollTo, {
  //   container: 'body',
  //   duration: 1500,
  //   easing: 'ease',
  //   offset: 0,
  //   cancelable: true,
  //   onDone: false,
  //   onCancel: false,
  //   x: false,
  //   y: true
  // })
}

export default vendors()



// WEBPACK FOOTER //
// ./src/resources/vendors.js